import React from "react";
import pic_wheel from '../assets/pic_wheel.png';

function Servizi() {
    return (
        <section className="py-5 darkerContainer">
            <div className="container">
                <h2 className="mb-4">Servizi</h2>
                <div className="row top-margin-15">
                    <div className="col-md-4">
                        <h5>Diritto civile</h5>
                        <p className={'justify-text white-color'}>Assistenza e consulenza in tutte le principali aree del diritto civile, con un approccio attento alle esigenze concrete delle persone e alla ricerca di soluzioni efficaci e sostenibili.</p>
                    </div>
                    <div className="col-md-4">
                        <h5>Responsabilità civile</h5>
                        <p className={'justify-text white-color'}>Assistenza nei casi di danni patrimoniali e non patrimoniali, sia in fase stragiudiziale sia giudiziale, per ottenere un risarcimento equo e proporzionato.</p>
                    </div>
                    <div className="col-md-4">
                        <h5>Diritto di famiglia</h5>
                        <p className={'justify-text white-color'}>Supporto legale in materia di separazioni, divorzi, affidamento dei figli e rapporti familiari, con particolare attenzione agli aspetti umani e alla tutela delle parti più fragili.</p>
                    </div>
                </div>

                <div className="row top-margin-15">
                    <div className="col-md-4">
                        <h5>Consulenza stragiudiziale</h5>
                        <p className={'justify-text white-color'}>Affiancamento nella gestione delle controversie prima del contenzioso, privilegiando il dialogo e le soluzioni alternative per ridurre tempi, costi e conflittualità.</p>
                    </div>
                    <div className="col-md-4">
                        <h5>Recupero crediti</h5>
                        <p className={'justify-text white-color'}>Assistenza nel recupero dei crediti, attraverso strumenti stragiudiziali e giudiziali, valutando di volta in volta la soluzione più efficace e meno onerosa.</p>
                    </div>
                    <div className="col-md-4">
                        <h5>Contrattualistica</h5>
                        <p className={'justify-text white-color'}>Redazione, revisione e interpretazione di contratti civili e commerciali, con l’obiettivo di prevenire controversie e tutelare gli interessi del cliente in modo chiaro e consapevole.</p>
                    </div>
                </div>

            </div>
            <div className={'wheel-container'}>
                <img src={pic_wheel} alt="logo studio legale" width="500" height="auto"/>
            </div>
        </section>
    );
}

export default Servizi;